import React, { FC } from 'react'

import { IconContactsProps } from './IconContacts.types'
import * as Styled from './styles/IconContacts.style'

import { nonThemeableRules } from '../../ruleSet'

const IconContacts: FC<IconContactsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconContactsProps['size'],
  isResponsive = false,
}: IconContactsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M10.212 5.133h31.825v33.93a4 4 0 0 1-4 4H10.212a4 4 0 0 1-4-4V9.133a4 4 0 0 1 4-4Z'
          stroke='#fff'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M36.188 43.063V5.133m0 7.967h5.85m-5.85 10.997h5.85m-5.85 11.078h5.85'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.392 34.13c-.875-5.932-4.5-9.75-8.08-9.75s-7.305 3.825-8.182 9.75'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M21.125 14.615h5.015v5.015a4.75 4.75 0 0 1-4.75 4.75h-.265a4.75 4.75 0 0 1-4.75-4.75v-.275a4.75 4.75 0 0 1 4.75-4.75v.01Z'
          stroke='#EA1A1A'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconContacts
